// eslint-disable-next-line
import { useState, useEffect } from "react";

import { auth, logInWithEmailAndPassword } from "../../util/firebase";

import { useAuthState } from "react-firebase-hooks/auth";

import {
  Link,
  // eslint-disable-next-line
  useNavigate,
} from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { Input, Button } from "reactstrap";

import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading] = useAuthState(auth);

  const { t } = useTranslation("common");

  const triggerAgeRestrictonPopup = () => {
    Swal.fire({
      title: t("childrenWarningTitle"),
      text: t("childrenWarningText"),
      icon: "warning",
      confirmButtonColor: "#005EE1",
      confirmButtonText: t("ok"),
    });
  };

  if (loading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="loginPage" className="signInPage">
      <div className="loginContainer">
        <div style={{ display: "flex", flexDirection: "column" }}>
          <h1>{t("signIn").toUpperCase()}</h1>
          <p
            className="inputLabel"
            style={{ textAlign: "left", marginTop: "1rem" }}
          >
            {t("email")}
          </p>
          <Input
            type="text"
            className="authInput"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t("yourEmail")}
          />
          <p className="inputLabel" style={{ textAlign: "left" }}>
            {t("password")}
          </p>
          <Input
            type="password"
            className="authInput"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder={t("yourPassword")}
          />
        </div>
        <Button
          className="primaryBtn"
          onClick={() => logInWithEmailAndPassword(email, password, t)}
          style={{ marginTop: "0.5rem" }}
        >
          {t("signIn").toUpperCase()}
        </Button>
        <Link className="authLink" to="/reset-password">
          {t("forgotYourPassword")}
        </Link>
        <p onClick={triggerAgeRestrictonPopup} style={{ marginBottom: 0 }}>
          {t("dontHaveAnAccount")}{" "}
          <Link className="authLink" to="/register">
            {t("register")}
          </Link>{" "}
          {t("here")}.
        </p>
      </div>
    </div>
  );
}

export default LoginPage;
